import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import MailboxPage from "./components/mailbox/MailboxPage";
import DomainAdminPage from "./components/admin/DomainAdminPage";
import LoginPage from "./components/auth/LoginPage";
import MainLayout from "./components/layout/MainLayout";
import DevtoolGuard from "./DevtoolGuard";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Public Layout with Header and Footer */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<MailboxPage />} />
        <Route path="/:address" element={<MailboxPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route element={<PrivateRoute />}>
          <Route path="/admin/domains" element={<DomainAdminPage />} />
        </Route>
      </Route>
    </Route>,
  ),
);
function App() {
  return (
    <div className="App">
      {/* <DevtoolGuard /> */}
      <RouterProvider router={router} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
